import React, { ComponentType } from "react";

export type HookPropsInjector<P> = (props: P) => Partial<P>;

function withHookProps<P>(Component: ComponentType<P>, fn: HookPropsInjector<P>) {
    return (props: P) => <Component {...props} {...fn(props)} />;
}

export default withHookProps;
